// src/api/publicProducts.js
import CONFIG from "../config/config";

/**
 * Devuelve los planes de Stripe accesibles sin token Cognito.
 * La clave x-api-key viaja en cabecera, no se envía Authorization.
 */
export async function fetchPublicProducts() {
  try {
    const res = await fetch(
      `${CONFIG.API_DOMAIN}${CONFIG.BASE_PATH}/stripe-get-products-public`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": CONFIG.GENERIC_API_KEY  
        },
      }
    );

    if (!res.ok) {
      throw new Error(`Error ${res.status} al obtener productos públicos.`);
    }

    return await res.json();                        // [{ id, name, unit_amount, currency, features, ... }]
  } catch (err) {
    console.error("fetchPublicProducts:", err);
    throw err;
  }
}

export async function fetchPublicPromotion({ path, locale } = {}) {
  const isBrowser = typeof window !== "undefined";

  const resolvedPath =
    path ?? (isBrowser && window.location?.pathname) ?? "/";

  const normalizeLocale = (raw) => {
    const first = String(raw || "es-ES").split(",")[0].trim().toLowerCase();
    return first.replace("_", "-");
  };

  const resolvedLocale = normalizeLocale(
    locale ?? (isBrowser && (navigator.language || (navigator.languages && navigator.languages[0]))) ?? "es-ES"
  );

  console.log(resolvedPath);
  console.log(resolvedLocale);

  const res = await fetch(`${CONFIG.API_DOMAIN}${CONFIG.BASE_PATH}/get-active-promotion`, {
    method: "GET",
    headers: {
      // "Content-Type": "application/json",
      "x-api-key": CONFIG.GENERIC_API_KEY,
      "X-Path": resolvedPath,
      "X-Locale": resolvedLocale
    },
  });

  if (!res.ok) throw new Error(`Error ${res.status} al obtener promoción pública.`);
  return res.json();
}
